import qs from 'query-string';
import _ from 'lodash';
import api from '../utils/api';

const applicationVndApiType = {
  headers: {
    'Content-Type': 'application/vnd.api+json',
  },
};

const returnsJSON = resp => resp.json();
const returnsData = resp => returnsJSON(resp)
  .then(({ data }) => data);

export const getMe = () => api('/v1/me').then(returnsData);

export const getAll = (request) => {
  const response = { data: [], included: [] };

  const processPage = promise => promise
    .then(resp => resp.json())
    .then(({ data, included = [], links: { next } }) => {
      response.data = [...response.data, ...data];
      response.included = [...response.included, ...included];

      return next ? processPage(api(next)) : response;
    });

  return processPage(request);
};

export const getAffiliate = affiliateId =>
  api(`/v1/affiliates/${affiliateId}`).then(returnsData);

export const getPermissions = (userId, affiliateId, options = { order: 'name', count: 100 }) => {
  const query = qs.stringify({
    ...options,
    user_id: userId,
    include: 'permission_group',
  });

  const getUserPermission = permissions =>
    _.first(permissions.filter(({ relationships: { user } }) => user.data.id === userId));

  return getAll(api(`/v1/affiliates/${affiliateId}/user_permissions?${query}`))
    .then(({ data: userPermissions, included: permissionGroups }) => ({
      user: getUserPermission(userPermissions),
      permissionGroups,
    }));
};

export const setAvailable = (affiliateId, permissionId, isAvailable) =>
  api(`/v1/affiliates/${affiliateId}/user_permissions/${permissionId}`, {
    ...applicationVndApiType,
    method: 'PATCH',
    body: JSON.stringify({
      data: {
        id: permissionId,
        type: 'user_permission',
        attributes: {
          is_available: isAvailable,
        },
      },
    }),
  }).then(returnsData);

export const getAffiliates = (count = 10) =>
  api(`/v1/affiliates?count=${count}`)
    .then(returnsData);

export const getAllAffiliates = (count = 50) =>
  getAll(api(`/v1/affiliates?count=${count}`))
    .then(({ data }) => data);



// WEBPACK FOOTER //
// ./src/api/index.js